import { Formik } from 'formik';
import * as Yup from "yup";
import React, { useState } from 'react';
import { Alert, Button, Col, Form, Input, InputGroup, Label, Row, Spinner } from 'reactstrap';
import { PostData } from '../../../services/FetchData';
import { useNavigate } from 'react-router-dom';

const CollectCustomSites = (props) => {
	const [errorMessages, setErrorMessages] = useState("");
	const navigate = useNavigate();


	const saveStoreInformation = (values, actions) => {
		const requestData = {
			storeURL: values.siteURL,
			feedUrl: values.feedURL,
		};

		PostData("ms1", "api/v1/website/saveCustomStore", requestData).then(result => {
			if (result !== "Invalid" && result !== undefined) {
				if (result.status === "success") {
					// Navigate to settings page with websiteKeys
					navigate("/getStarted/customPlatformSettings", { 
						state: { websiteKeys: result.data.websiteKeys },
						replace: true 
					});

				} else if (result.status === "failure") {
					setErrorMessages(result.message)
				} else {
					setErrorMessages(result.message.message)
				}
			}
			actions.setSubmitting(false)
		})
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>Store Information</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={6} className='text-center d-none d-lg-block'>
							<img src={require("./../../../assets/images/integration.png")} alt="integration" className='img-fluid' />
						</Col>
						<Col xs={12} lg={6}>
							{errorMessages !== "" && (
								<Alert color="danger">
									{errorMessages}
								</Alert>
							)}
							<div className='storeInformationWrapper'>
								<Formik
									initialValues={{ feedURL: "", siteURL: "" }}
									onSubmit={(values, actions) => {
										saveStoreInformation(values, actions)
									}}
									validationSchema={Yup.object().shape({
										feedURL: Yup.string().required("Feed URL is required").url("Please enter valid feed URL"),
										siteURL: Yup.string().required("Site URL is required").url("Please enter valid site URL")
									})}
								>
									{props => {
										const {
											values,
											touched,
											errors,
											isSubmitting,
											handleChange,
											handleBlur,
											handleSubmit
										} = props;
										return (
											<Form role="form" onSubmit={handleSubmit} noValidate>
												<div className={`position-relative mb-5 ${(errors.feedURL && touched.feedURL && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Feed URL
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="Feed URL"
															type={"text"}
															name="feedURL"
															value={values.feedURL}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																"col" ||
																(errors.feedURL && touched.feedURL && "error")
															}
															autofill="false"
														/>
													</InputGroup>
													{errors.feedURL && touched.feedURL && (
														<div className="input-feedback">{errors.feedURL}</div>
													)}
												</div>
												<div className={`position-relative mb-5 ${(errors.siteURL && touched.siteURL && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Site URL
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="Site URL"
															type={"text"}
															name="siteURL"
															value={values.siteURL}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																"col" ||
																(errors.siteURL && touched.siteURL && "error")
															}
															autofill="false"
														/>
													</InputGroup>
													{errors.siteURL && touched.siteURL && (
														<div className="input-feedback">{errors.siteURL}</div>
													)}
												</div>
												<div className="d-flex justify-content-center">
													{isSubmitting ? (
														<Button className="cta authCta" color="primary" type="button" disabled>
															<Spinner
																className="white mr-1"
																size="sm"
																color="light"
															/>
															<span className="ml-2 d-inline-block">Loading</span>
														</Button>
													) : (
														<Button className=" cta authCta " color="primary" type="submit">Save</Button>
													)}
												</div>
											</Form>)
									}}
								</Formik>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default CollectCustomSites;

